import { Skeleton } from "antd";
import SectionCardSkeleton from "./SectionCardSkeleton";

const InsuranceDocumentsSkeleton = () => (
    <SectionCardSkeleton>
        <Skeleton active title={{ width: "40%" }} paragraph={false} className="!mb-4" />
        <div className="flex flex-col gap-3">
            <Skeleton.Node active className="!h-[76px] !w-full !rounded-xl" style={{ width: "100%" }} />
            <Skeleton.Node active className="!h-[76px] !w-full !rounded-xl" style={{ width: "100%" }} />
        </div>
    </SectionCardSkeleton>
);

export default InsuranceDocumentsSkeleton;
